import React from "react";

import { withStyles } from '@mui/styles';

import { zipObject } from "lodash";

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from '@mui/material';

import InfiniteScroll from 'react-infinite-scroll-component';

import CommonStyles from "../../common/CommonStyles";
import ComponentWrapper from "../../common/ComponentWrapper";
import LoaderNew from "../../common/LoaderNew";

const styles = {
  ...CommonStyles,
};

class Unsubscriptions extends ComponentWrapper {
  state = {
    data: [],
    rawData: [],
    filteredData: [],
    hasMore: true,
    loadedItems: 0,
    itemsPerFetch: 60,
    searchQuery: "",
  };

  componentDidMount() {
    this.get({
      url: '/rest/get_unsubscriptions',
      cb: (res) => {
        if (res && res.data) {
          const data = res.data.reverse();
          this.setState({ rawData: data, filteredData: data, loaded: true }, this.fetchData);
        }
      },
      errorCb: () => this.setState({ loaded: true }),
      disableNotify: true,
    });
  }

  handleSearch = (event) => {
    const query = event.target.value.toLowerCase().trim();
    const filtered = this.state.rawData.filter((item) =>
      item[1].toLowerCase().includes(query) || item[2].toLowerCase().includes(query)
    );
    this.setState({ searchQuery: query, filteredData: filtered, loadedItems: 0, data: [] }, this.fetchData);
  };

  fetchData = () => {
    const { loadedItems, itemsPerFetch, filteredData } = this.state;

    // Determine the slice of data to load
    const nextItems = filteredData.slice(loadedItems, loadedItems + itemsPerFetch);

    // Transform data using lodash zipObject for structured keys
    const transformedData = nextItems.map(item =>
      zipObject([
        "ID", "SenderEmail", "RecipientEmail", "PID", "Reason", "Comment", "Time"
      ], item)
    ).map(item => ({
      ...item,
      Reason: item.Reason,
      Time: new Date(item.Time).toLocaleString(),
    }));

    this.setState((prevState) => ({
      data: [...prevState.data, ...transformedData],
      hasMore: loadedItems + itemsPerFetch < filteredData.length,
      loadedItems: prevState.loadedItems + itemsPerFetch,
    }));
  };

  render() {
    const { classes } = this.props;
    const { data, hasMore, searchQuery } = this.state;

    return (
      <div>
        <div>
          <div className={`${classes.pageHeading} ${classes.alignEnd}`}>
            <h3>Unsubscriptions</h3>

            <TextField
              variant="outlined"
              placeholder="Search by email (Sender or Recipient)"
              value={searchQuery}
              onChange={this.handleSearch}
              sx={{ width: '400px', marginLeft: '30px' }}
            />
          </div>
        </div>
        <div style={{ margin: '10px 30px', height: '100%', overflow: 'hidden' }}>

          <InfiniteScroll
            dataLength={data.length}
            next={this.fetchData}
            hasMore={hasMore}
            loader={<LoaderNew style={{ margin: '10px auto' }} />}
            endMessage={<p style={{ textAlign: 'center', color: '#BAB9DB' }}>No more data to load</p>}
          >
            <TableContainer>
              <Table
                style={{ height: 'fit-content' }}
              >
                <TableHead>
                  <TableRow>
                    <TableCell className={`${classes.columnHeadingGeneral}`}>ID</TableCell>
                    <TableCell className={`${classes.columnHeadingGeneral}`}>Sender Email</TableCell>
                    <TableCell className={`${classes.columnHeadingGeneral}`}>Recipient Email</TableCell>
                    <TableCell className={`${classes.columnHeadingGeneral}`}>PID</TableCell>
                    <TableCell className={`${classes.columnHeadingGeneral}`}>Code</TableCell>
                    <TableCell className={`${classes.columnHeadingGeneral}`}>Comment</TableCell>
                    <TableCell className={`${classes.columnHeadingGeneral}`}>Time</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody style={{ backgroundColor: '#fff', paddding: '0 10px' }}>
                  {data.map((row, index) => (
                    <TableRow key={index} className={`${classes.tableRow}`} style={{ padding: '2px 5px', fontWeight: row.Reason === 0 ? 900 : 450, color: row.Reason === 0 ? '' : '#9797C0'  }}>
                      <TableCell className={classes.tCell}><div style={{ padding: '2px 5px' }}>{row.ID}</div></TableCell>
                      <TableCell className={classes.tCell}><div style={{ padding: '2px 5px' }}>{row.SenderEmail}</div></TableCell>
                      <TableCell className={classes.tCell}><div style={{ padding: '2px 5px' }}>{row.RecipientEmail}</div></TableCell>
                      <TableCell className={classes.tCell}><div style={{ padding: '2px 5px' }}>{row.PID}</div></TableCell>
                      <TableCell className={`${classes.tCell} ${classes.nowrap}`}><span>{row.Reason}</span></TableCell>
                      <TableCell className={`${classes.tCell}`}><div style={{ padding: '2px 5px' }}>{row.Comment}</div></TableCell>
                      <TableCell className={`${classes.tCell} ${classes.nowrap}`}><div style={{ padding: '2px 5px' }}>{row.Time}</div></TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </InfiniteScroll>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(Unsubscriptions);
